// extracted by mini-css-extract-plugin
module.exports = {"card":"card__hndE7","preview":"preview__3ilme","text":"text__Vnf9_","stats":"stats___TTsG","checked":"checked__3Ep_R","price":"price__y9fyc","info":"info__3yV-n"};